// src/components/UIShowcase.js
import React, { useState } from 'react';
import UI from '../ui-components';

const UIShowcase = () => {
  const [isPublished, setIsPublished] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [rating, setRating] = useState(3);
  const [likes, setLikes] = useState(15);
  const [dislikes, setDislikes] = useState(2);
  const [userVote, setUserVote] = useState(null);

  const handleLike = () => {
    if (userVote === 'like') {
      setLikes(likes - 1);
      setUserVote(null);
    } else {
      setLikes(userVote === 'dislike' ? likes + 2 : likes + 1);
      setDislikes(userVote === 'dislike' ? dislikes - 1 : dislikes);
      setUserVote('like');
    }
  };

  const handleDislike = () => {
    if (userVote === 'dislike') {
      setDislikes(dislikes - 1);
      setUserVote(null);
    } else {
      setDislikes(userVote === 'like' ? dislikes + 2 : dislikes + 1);
      setLikes(userVote === 'like' ? likes - 1 : likes);
      setUserVote('dislike');
    }
  };

  return (
    <div className="container-fluid p-4 bg-light min-vh-100">
      <div className="row">
        <div className="col-12">
          <h1 className="text-center mb-4 text-primary">UI Components Showcase</h1>

          {/* Core Components Section */}
          <section className="card mb-4">
            <div className="card-header bg-primary text-white">
              <h3 className="mb-0">Core Components</h3>
            </div>
            <div className="card-body">
              <div className="row g-3 align-items-center">
                <div className="col-md-3">
                  <UI.ActionButton variant="primary">Action Button</UI.ActionButton>
                  <small className="text-muted d-block mt-1">ActionButton</small>
                </div>
                <div className="col-md-3">
                  <UI.ToggleSwitch 
                    id="toggle1" 
                    checked={isPublished} 
                    onChange={() => setIsPublished(!isPublished)} 
                  />
                  <small className="text-muted d-block mt-1">ToggleSwitch</small>
                </div>
                <div className="col-md-3">
                  <UI.StarRating 
                    rating={rating} 
                    onRate={setRating} 
                  />
                  <small className="text-muted d-block mt-1">StarRating</small>
                </div>
                <div className="col-md-3">
                  <UI.ThumbsRating 
                    likes={likes}
                    dislikes={dislikes}
                    userVote={userVote}
                    onLike={handleLike}
                    onDislike={handleDislike}
                  />
                  <small className="text-muted d-block mt-1">ThumbsRating</small>
                </div>
                <div className="col-md-3">
                  <UI.ViewCount count={1234} />
                  <small className="text-muted d-block mt-1">ViewCount</small>
                </div>
                <div className="col-md-3">
                  <UI.StatusLabel variant="success">Status Label</UI.StatusLabel>
                  <small className="text-muted d-block mt-1">StatusLabel</small>
                </div>
              </div>
            </div>
          </section>

          {/* Core Action Buttons Section */}
          <section className="card mb-4">
            <div className="card-header bg-success text-white">
              <h3 className="mb-0">Core Action Buttons</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {[
                  { Component: UI.ViewButton, name: 'View' },
                  { Component: UI.EditButton, name: 'Edit' },
                  { Component: UI.UpdateButton, name: 'Update' },
                  { Component: UI.DeleteButton, name: 'Delete' },
                  { Component: UI.AddButton, name: 'Add' },
                  { Component: UI.SaveButton, name: 'Save' },
                  { Component: UI.CancelButton, name: 'Cancel' },
                  { Component: UI.ConfirmButton, name: 'Confirm' },
                  { Component: UI.ClearButton, name: 'Clear' },
                  { Component: UI.LinkButton, name: 'Link' },
                  { Component: UI.TransferButton, name: 'Transfer' },
                  { Component: UI.SeeMoreButton, name: 'See More' }
                ].map(({ Component, name }) => (
                  <div key={name} className="col-md-3 col-sm-4 col-6">
                    <Component />
                    <small className="text-muted d-block mt-1">{name}Button</small>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Premium Button Variants Section */}
          {[
            {
              title: 'Premium View Button Variants',
              baseName: 'ViewButton',
              variants: [
           
                { Component: UI.ViewButtonRounded, name: 'Rounded' },
               
                { Component: UI.ViewButtonIconOnly, name: 'Icon Only' },
               
              ]
            },
            {
              title: 'Premium Edit Button Variants',
              baseName: 'EditButton',
              variants: [
                { Component: UI.EditButtonRounded, name: 'Rounded' },
                { Component: UI.EditButtonIconOnly, name: 'Icon Only' },
                
              ]
            },
            {
              title: 'Premium Delete Button Variants',
              baseName: 'DeleteButton',
              variants: [
           
            
                { Component: UI.DeleteButtonRounded, name: 'Rounded' },
                
                { Component: UI.DeleteButtonIconOnly, name: 'Icon Only' },
                        
              ]
            },
            {
              title: 'Premium Add Button Variants',
              baseName: 'AddButton',
              variants: [
              
                { Component: UI.AddButtonRounded, name: 'Rounded' },
                { Component: UI.AddButtonIconOnly, name: 'Icon Only' },
             
              ]
            },
            {
              title: 'Premium Save Button Variants',
              baseName: 'SaveButton',
              variants: [
                { Component: UI.SaveButtonRounded, name: 'Rounded' },
                { Component: UI.SaveButtonIconOnly, name: 'Icon Only' },
              ]
            },
            {
              title: 'Premium Cancel Button Variants',
              baseName: 'CancelButton',
              variants: [
                { Component: UI.CancelButtonRounded, name: 'Rounded' },
                { Component: UI.CancelButtonIconOnly, name: 'Icon Only' },

              ]
            },
            {
              title: 'Premium Clear Button Variants',
              baseName: 'ClearButton',
              variants: [
               
                { Component: UI.ClearButtonRounded, name: 'Rounded' },
                { Component: UI.ClearButtonIconOnly, name: 'Icon Only' },
       
              ]
            }
          ].map((section, sectionIndex) => (
            <section key={sectionIndex} className="card mb-4">
              <div className="card-header bg-info text-white">
                <h3 className="mb-0">{section.title}</h3>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  {section.variants.map(({ Component, name }) => (
                    <div key={name} className="col-md-3 col-sm-4 col-6">
                      <Component />
                      <small className="text-muted d-block mt-1">
                        {section.baseName}{name.replace(' ', '')}
                      </small>
                      <small className="text-muted d-block">{name}</small>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          ))}

          {/* Additional Premium Buttons */}
          <section className="card mb-4">
            <div className="card-header bg-warning text-dark">
              <h3 className="mb-0">Additional Premium Buttons</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {[
                  { Component: UI.DownloadButton, name: 'Download' },
                  { Component: UI.UploadButton, name: 'Upload' },
                  { Component: UI.FilterButton, name: 'Filter' }
                ].map(({ Component, name }) => (
                  <div key={name} className="col-md-4">
                    <Component />
                    <small className="text-muted d-block mt-1">{name}Button</small>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Outline Buttons */}
          <section className="card mb-4">
            <div className="card-header bg-secondary text-white">
              <h3 className="mb-0">Outline Buttons</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {[
                  { Component: UI.OutlineViewButton, name: 'Outline View' },
                  { Component: UI.OutlineEditButton, name: 'Outline Edit' },
                  { Component: UI.OutlineDeleteButton, name: 'Outline Delete' }
                ].map(({ Component, name }) => (
                  <div key={name} className="col-md-4">
                    <Component />
                    <small className="text-muted d-block mt-1">{name.replace(' ', '')}Button</small>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Enhanced Toggle Buttons */}
          <section className="card mb-4">
            <div className="card-header bg-dark text-white">
              <h3 className="mb-0">Enhanced Toggle Buttons</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <UI.PublishToggle 
                    isPublished={isPublished} 
                    onToggle={setIsPublished}
                  />
                  <small className="text-muted d-block mt-1">PublishToggle</small>
                </div>
                <div className="col-md-6">
                  <UI.StatusToggle 
                    isActive={isActive} 
                    onToggle={setIsActive}
                  />
                  <small className="text-muted d-block mt-1">StatusToggle</small>
                </div>
              </div>
            </div>
          </section>

          {/* Premium Status Labels */}
          <section className="card mb-4">
            <div className="card-header bg-danger text-white">
              <h3 className="mb-0">Premium Status Label Components</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {[
                  { Component: UI.SpecialtyLabel, name: 'Specialty', props: { children: 'Expert' } },
                  { Component: UI.NotificationLabel, name: 'Notification', props: { count: 5 } },
                  { Component: UI.PendingLabel, name: 'Pending' },
                  { Component: UI.OnlineLabel, name: 'Online' },
                  { Component: UI.ProcessingLabel, name: 'Processing' },
                  { Component: UI.PaidLabel, name: 'Paid' },
                  { Component: UI.CancelLabel, name: 'Cancel' },
                  { Component: UI.PublishLabel, name: 'Publish' },
                  { Component: UI.UnpublishLabel, name: 'Unpublish' },
                  { Component: UI.FailedLabel, name: 'Failed' }
                ].map(({ Component, name, props = {} }) => (
                  <div key={name} className="col-md-3 col-sm-4 col-6">
                    <Component {...props} />
                    <small className="text-muted d-block mt-1">{name}Label</small>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Additional Status Labels */}
          <section className="card mb-4">
            <div className="card-header bg-primary text-white">
              <h3 className="mb-0">Additional Status Labels</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {[
                  { Component: UI.CreatedLabel, name: 'Created' },
                  { Component: UI.DraftLabel, name: 'Draft' },
                  { Component: UI.EditedLabel, name: 'Edited' },
                  { Component: UI.ActiveLabel, name: 'Active' },
                  { Component: UI.SubscriptionLabel, name: 'Subscription' },
                  { Component: UI.CompleteLabel, name: 'Complete' },
                  { Component: UI.PendingLightLabel, name: 'Pending Light' },
                  { Component: UI.OnlineLightLabel, name: 'Online Light' },
                  { Component: UI.ProcessingLightLabel, name: 'Processing Light' },
                  { Component: UI.PaidLightLabel, name: 'Paid Light' },
                  { Component: UI.CancelLightLabel, name: 'Cancel Light' },
                  { Component: UI.PublishLightLabel, name: 'Publish Light' },
                  { Component: UI.UnpublishLightLabel, name: 'Unpublish Light' },
                  { Component: UI.FailedLightLabel, name: 'Failed Light' },
                  { Component: UI.ConfirmLabel, name: 'Confirm' },
                  { Component: UI.NotBilledLabel, name: 'Not Billed' },
                  { Component: UI.CountBadge, name: 'Count Badge', props: { count: 42 } },
                  { 
                    Component: UI.RemovableSpecialtyLabel, 
                    name: 'Removable Specialty', 
                    props: { 
                      children: 'Expert',
                      onRemove: () => alert('Remove clicked!')
                    } 
                  }
                ].map(({ Component, name, props = {} }) => (
                  <div key={name} className="col-md-3 col-sm-4 col-6">
                    <Component {...props} />
                    <small className="text-muted d-block mt-1">{name.replace(' ', '')}Label</small>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Notification Badge */}
          <section className="card mb-4">
            <div className="card-header bg-warning text-dark">
              <h3 className="mb-0">Notification Badge Component</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-4">
                  <div className="d-flex align-items-center">
                    <span className="me-3">Notifications:</span>
                    <UI.NotificationBadge count={5} />
                  </div>
                  <small className="text-muted d-block mt-1">NotificationBadge</small>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-center">
                    <span className="me-3">Small:</span>
                    <UI.NotificationBadge count={3} size="sm" />
                  </div>
                  <small className="text-muted d-block mt-1">Small Size</small>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-center">
                    <span className="me-3">Large:</span>
                    <UI.NotificationBadge count={99} size="lg" />
                  </div>
                  <small className="text-muted d-block mt-1">Large Size</small>
                </div>
              </div>
            </div>
          </section>

          {/* Button Groups */}
          <section className="card mb-4">
            <div className="card-header bg-info text-white">
              <h3 className="mb-0">Button Group Components</h3>
            </div>
            <div className="card-body">
              <div className="row g-4">
                <div className="col-md-6">
                  <h5>ButtonGroup</h5>
                  <UI.ButtonGroup>
                    <UI.ViewButton size="sm" />
                    <UI.EditButton size="sm" />
                    <UI.DeleteButton size="sm" />
                  </UI.ButtonGroup>
                  <small className="text-muted d-block mt-1">Custom Button Group</small>
                </div>
                <div className="col-md-6">
                  <h5>ActionButtonGroup</h5>
                  <UI.ActionButtonGroup 
                    onView={() => alert('View clicked!')}
                    onEdit={() => alert('Edit clicked!')}
                    onDelete={() => alert('Delete clicked!')}
                  />
                  <small className="text-muted d-block mt-1">Pre-built Action Group</small>
                </div>
              </div>
            </div>
          </section>

          {/* Submit Buttons */}
          <section className="card mb-4">
            <div className="card-header bg-success text-white">
              <h3 className="mb-0">Submit Buttons</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {[
                  { Component: UI.SubmitButton, name: 'Submit' },
                  { Component: UI.SaveChangesButton, name: 'Save Changes' },
                  { Component: UI.UpdateProfileButton, name: 'Update Profile' }
                ].map(({ Component, name }) => (
                  <div key={name} className="col-md-4">
                    <Component />
                    <small className="text-muted d-block mt-1">{name.replace(' ', '')}Button</small>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Special Buttons */}
          <section className="card mb-4">
            <div className="card-header bg-dark text-white">
              <h3 className="mb-0">Special Buttons</h3>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {[
                  { Component: UI.BookNowButton, name: 'Book Now' },
                  { Component: UI.SetHolidayButton, name: 'Set Holiday' },
                  { Component: UI.ViewProfileButton, name: 'View Profile' }
                ].map(({ Component, name }) => (
                  <div key={name} className="col-md-4">
                    <Component />
                    <small className="text-muted d-block mt-1">{name.replace(' ', '')}Button</small>
                  </div>
                ))}
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default UIShowcase;